<div class="flex flex-col max-w-160 md:min-w-160 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>


    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="builtUpAreaLandForm">
        <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>

        <mat-form-field>
            <mat-label>Type</mat-label>
            <input matInput [formControlName]="'type'">
            <mat-error *ngIf="builtUpAreaLandForm.get('type').hasError('required')">
                Type is required
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Area</mat-label>
            <input matInput [formControlName]="'area'" [value]="builtUpAreaLandForm.get('area').value" type="number"
                class="text-right">
        </mat-form-field>
        <mat-form-field>
            <mat-label>AreaAsPer</mat-label>
            <input type="text" matInput [formControl]="builtUpAreaLandForm.get('areaAsPer')"
                [matAutocomplete]="autoAreaAsPer">
            <mat-autocomplete #autoAreaAsPer="matAutocomplete" [displayWith]="displayOptionsFn(options)">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
                    {{option.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>

            <div class="flex items-center mt-4 sm:mt-0">
                <div class="flex">
                    <button class="order-first sm:order-last" *ngIf="builtUpAreaLand && builtUpAreaLand.id > 0"
                        mat-flat-button [color]="'primary'" (click)="updateAndClose()">
                        Update
                    </button>

                    <button class="order-first sm:order-last " *ngIf="!builtUpAreaLand" mat-flat-button
                        [disabled]="!builtUpAreaLandForm.valid" [color]="'primary'" (click)="saveAndNew()">
                        Save & New
                    </button>
                </div>
                <div class="flex pl-2">
                    <button class="order-first sm:order-last" *ngIf="!builtUpAreaLand" mat-flat-button
                        [disabled]="!builtUpAreaLandForm.valid" [color]="'primary'" (click)="saveAndClose()">
                        Save & Close
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>